import React from 'react';
import { makeStyles } from 'src/makeStyles';
import CircularProgress from '@mui/material/CircularProgress';
import { colors } from '../../constants/styleConstants';

import { LOADER_VARIANTS } from '../../constants/consts';

const useStyles = makeStyles()((theme, props) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: 10,
    '& circle': {
      color: props.variant === LOADER_VARIANTS.PRIMARY ? colors.blue3 : theme.palette.primary.main,
    },
  },
}));

const FbCircularProgress = ({ className, variant, ...props }) => {
  const { classes, cx } = useStyles({ variant });

  return (
    <div className={cx(classes.root, className)}>
      <CircularProgress {...props} />
    </div>
  );
};

FbCircularProgress.defaultProps = {
  variant: LOADER_VARIANTS.SECONDARY,
};

export default FbCircularProgress;
